import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface IFixedDepositLeadsState {
  data?: {
    data?: any[]
    meta?: any
  }
  loading?: boolean
}

const initialState: IFixedDepositLeadsState = {
  data: {data: [], meta: {}},
  loading: false,
}

export const reducer = (
  state: IFixedDepositLeadsState = initialState,
  action: ActionWithPayload<IFixedDepositLeadsState>
) => {
  switch (action.type) {
    case actionTypes.GET_FIXED_DEPOSIT_LEADS_START:
      return {...state, loading: true}
    case actionTypes.GET_FIXED_DEPOSIT_LEADS_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_FIXED_DEPOSIT_LEADS_FINISH:
      return {...state, loading: false}
    default:
      return state
  }
}
